module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Gja8"))).then(() => parcelRequire('3a9aZ'));